export const SOCIAL_FUSION_HOLIDAYS = {
    "01-01": "New Year's Day",
    "01-02": "Science Fiction Day",
    "01-03": "Festival of Sleep Day",
    "01-04": "World Braille Day",
    "01-05": "National Bird Day",
    "01-06": "Epiphany",
    "01-07": "Orthodox Christmas Day",
    "01-08": "Bubble Bath Day",
    "01-09": "Law Enforcement Appreciation Day",
    "01-10": "Houseplant Appreciation Day",
    "01-11": "Learn Your Name in Morse Code Day",
    "01-12": "National Pharmacist Day",
    "01-13": "Make Your Dream Come True Day",
    "01-14": "Dress Up Your Pet Day",
    "01-15": "National Hat Day",
    "01-16": "Nothing Day",
    "01-17": "Ditch New Year's Resolution Day",
    "01-18": "Winnie the Pooh Day",
    "01-19": "Popcorn Day",
    "01-20": "Martin Luther King Jr. Day",
    "01-21": "National Hugging Day",
    "01-22": "Celebration of Life Day",
    "01-23": "Handwriting Day",
    "01-24": "Compliment Day",
    "01-25": "Opposite Day",
    "01-26": "Australia Day",
    "01-27": "Chocolate Cake Day",
    "01-28": "Data Privacy Day",
    "01-29": "Puzzle Day",
    "01-30": "Croissant Day",
    "01-31": "Backward Day",
    "02-01": "National Freedom Day",
    "02-02": "Groundhog Day",
    "02-03": "Golden Retriever Day",
    "02-04": "World Cancer Day",
    "02-05": "National Weatherperson's Day",
    "02-06": "Frozen Yogurt Day",
    "02-07": "Send a Card to a Friend Day",
    "02-08": "Laugh and Get Rich Day",
    "02-09": "Pizza Day",
    "02-10": "Umbrella Day",
    "02-11": "Inventors' Day",
    "02-12": "Darwin Day",
    "02-13": "Galentine's Day",
    "02-14": "Valentine's Day",
    "02-15": "Susan B. Anthony Day",
    "02-16": "Do a Grouch a Favor Day",
    "02-17": "Random Acts of Kindness Day",
    "02-18": "Drink Wine Day",
    "02-19": "Chocolate Mint Day",
    "02-20": "Love Your Pet Day",
    "02-21": "International Mother Language Day",
    "02-22": "Margarita Day",
    "02-23": "Banana Bread Day",
    "02-24": "Tortilla Chip Day",
    "02-25": "Clam Chowder Day",
    "02-26": "Tell a Fairy Tale Day",
    "02-27": "Strawberry Day",
    "02-28": "Public Sleeping Day",
    "03-01": "World Compliment Day",
    "03-02": "Old Stuff Day",
    "03-03": "World Wildlife Day",
    "03-04": "Grammar Day",
    "03-05": "Cheese Doodle Day",
    "03-06": "Dentist's Day",
    "03-07": "Cereal Day",
    "03-08": "International Women's Day",
    "03-09": "Panic Day",
    "03-10": "Mario Day",
    "03-11": "Worship of Tools Day",
    "03-12": "Plant a Flower Day",
    "03-13": "Smart & Sexy Day",
    "03-14": "Pi Day",
    "03-15": "Ides of March",
    "03-16": "Everything You Do is Right Day",
    "03-17": "St. Patrick's Day",
    "03-18": "Awkward Moments Day",
    "03-19": "Let's Laugh Day",
    "03-20": "International Day of Happiness",
    "03-21": "World Poetry Day",
    "03-22": "Goof Off Day",
    "03-23": "Puppy Day",
    "03-24": "Chocolate Covered Raisins Day",
    "03-25": "Tolkien Reading Day",
    "03-26": "Spinach Day",
    "03-27": "World Theatre Day",
    "03-28": "Something on a Stick Day",
    "03-29": "Smoke and Mirrors Day",
    "03-30": "Doctors' Day",
    "03-31": "Crayon Day",
    "04-01": "April Fools' Day",
    "04-02": "Peanut Butter and Jelly Day",
    "04-03": "Find a Rainbow Day",
    "04-04": "Walk Around Things Day",
    "04-05": "Deep Dish Pizza Day",
    "04-06": "Carbonara Day",
    "04-07": "World Health Day",
    "04-08": "Zoo Lovers Day",
    "04-09": "Winston Churchill Day",
    "04-10": "Siblings Day",
    "04-11": "Pet Day",
    "04-12": "Grilled Cheese Sandwich Day",
    "04-13": "Scrabble Day",
    "04-14": "Look Up at the Sky Day",
    "04-15": "Tax Day (USA)",
    "04-16": "Wear Pajamas to Work Day",
    "04-17": "Haiku Poetry Day",
    "04-18": "Columnists Day",
    "04-19": "Garlic Day",
    "04-20": "Volunteer Recognition Day",
    "04-21": "Kindergarten Day",
    "04-22": "Earth Day",
    "04-23": "World Book Day",
    "04-24": "Pig in a Blanket Day",
    "04-25": "DNA Day",
    "04-26": "Pretzel Day",
    "04-27": "Tell a Story Day",
    "04-28": "Superhero Day",
    "04-29": "Dance Day",
    "04-30": "Honesty Day",
    "05-01": "May Day",
    "05-02": "World Tuna Day",
    "05-03": "Lemonade Day",
    "05-04": "Star Wars Day",
    "05-05": "Cinco de Mayo",
    "05-06": "Nurses Day",
    "05-07": "No Pants Day",
    "05-08": "World Red Cross Day",
    "05-09": "Lost Sock Memorial Day",
    "05-10": "Clean Up Your Room Day",
    "05-11": "Twilight Zone Day",
    "05-12": "Limerick Day",
    "05-13": "Apple Pie Day",
    "05-14": "Dance Like a Chicken Day",
    "05-15": "Chocolate Chip Day",
    "05-16": "Love a Tree Day",
    "05-17": "Pack Rat Day",
    "05-18": "No Dirty Dishes Day",
    "05-19": "Devil's Food Cake Day",
    "05-20": "Be a Millionaire Day",
    "05-21": "Talk Like Yoda Day",
    "05-22": "Sherlock Holmes Day",
    "05-23": "Taffy Day",
    "05-24": "Scavenger Hunt Day",
    "05-25": "Towel Day",
    "05-26": "Blueberry Cheesecake Day",
    "05-27": "Sunscreen Day",
    "05-28": "Hamburger Day",
    "05-29": "Paperclip Day",
    "05-30": "Mint Julep Day",
    "05-31": "Macaroon Day",
    "06-01": "Say Something Nice Day",
    "06-02": "Rocky Road Day",
    "06-03": "Repeat Day",
    "06-04": "Cheese Day",
    "06-05": "World Environment Day",
    "06-06": "D-Day Anniversary",
    "06-07": "Chocolate Ice Cream Day",
    "06-08": "Best Friends Day",
    "06-09": "Donald Duck Day",
    "06-10": "Iced Tea Day",
    "06-11": "Corn on the Cob Day",
    "06-12": "Loving Day",
    "06-13": "Sewing Machine Day",
    "06-14": "Flag Day (USA)",
    "06-15": "Nature Photography Day",
    "06-16": "Fresh Veggies Day",
    "06-17": "Eat Your Vegetables Day",
    "06-18": "Go Fishing Day",
    "06-19": "Juneteenth",
    "06-20": "Ice Cream Soda Day",
    "06-21": "International Yoga Day",
    "06-22": "Onion Rings Day",
    "06-23": "Pink Day",
    "06-24": "Fairy Day",
    "06-25": "Catfish Day",
    "06-26": "Chocolate Pudding Day",
    "06-27": "Pineapple Day",
    "06-28": "Paul Bunyan Day",
    "06-29": "Camera Day",
    "06-30": "Meteor Watch Day",
    "07-01": "International Joke Day",
    "07-02": "World UFO Day",
    "07-03": "Stay Out of the Sun Day",
    "07-04": "Independence Day (USA)",
    "07-05": "Workaholics Day",
    "07-06": "Fried Chicken Day",
    "07-07": "World Chocolate Day",
    "07-08": "Video Games Day",
    "07-09": "Sugar Cookie Day",
    "07-10": "Pina Colada Day",
    "07-11": "Cheer Up the Lonely Day",
    "07-12": "Paper Bag Day",
    "07-13": "French Fries Day",
    "07-14": "Mac & Cheese Day",
    "07-15": "Gummi Worm Day",
    "07-16": "Fresh Spinach Day",
    "07-17": "World Emoji Day",
    "07-18": "Caviar Day",
    "07-19": "Daiquiri Day",
    "07-20": "Moon Landing Day",
    "07-21": "Junk Food Day",
    "07-22": "Hammock Day",
    "07-23": "Vanilla Ice Cream Day",
    "07-24": "Cousins Day",
    "07-25": "Wine and Cheese Day",
    "07-26": "Aunt and Uncle Day",
    "07-27": "Scotch Whisky Day",
    "07-28": "Milk Chocolate Day",
    "07-29": "Lasagna Day",
    "07-30": "International Friendship Day",
    "07-31": "Mutt Day",
    "08-01": "Spider-Man Day",
    "08-02": "Ice Cream Sandwich Day",
    "08-03": "Watermelon Day",
    "08-04": "Chocolate Chip Cookie Day",
    "08-05": "Work Like a Dog Day",
    "08-06": "Root Beer Float Day",
    "08-07": "Purple Heart Day",
    "08-08": "International Cat Day",
    "08-09": "Book Lovers Day",
    "08-10": "S'mores Day",
    "08-11": "Mountain Day (Japan)",
    "08-12": "Middle Child Day",
    "08-13": "Left-Handers Day",
    "08-14": "Creamsicle Day",
    "08-15": "Relaxation Day",
    "08-16": "Tell a Joke Day",
    "08-17": "Black Cat Appreciation Day",
    "08-18": "Serendipity Day",
    "08-19": "World Photography Day",
    "08-20": "Lemonade Day",
    "08-21": "Senior Citizens Day",
    "08-22": "Be an Angel Day",
    "08-23": "Ride the Wind Day",
    "08-24": "Pluto Demoted Day",
    "08-25": "Banana Split Day",
    "08-26": "Dog Day",
    "08-27": "Just Because Day",
    "08-28": "Bow Tie Day",
    "08-29": "More Herbs, Less Salt Day",
    "08-30": "Beach Day",
    "08-31": "Trail Mix Day",
    "09-01": "Labor Day (USA)",
    "09-02": "Blueberry Popsicle Day",
    "09-03": "Skyscraper Day",
    "09-04": "Wildlife Day",
    "09-05": "Cheese Pizza Day",
    "09-06": "Read a Book Day",
    "09-07": "Grandparents Day",
    "09-08": "Literacy Day",
    "09-09": "Teddy Bear Day",
    "09-10": "Swap Ideas Day",
    "09-11": "Patriot Day",
    "09-12": "Chocolate Milkshake Day",
    "09-13": "Fortune Cookie Day",
    "09-14": "Cream-Filled Doughnut Day",
    "09-15": "Make a Hat Day",
    "09-16": "Guacamole Day",
    "09-17": "Apple Dumpling Day",
    "09-18": "Cheeseburger Day",
    "09-19": "Talk Like a Pirate Day",
    "09-20": "Punch Day",
    "09-21": "World Gratitude Day",
    "09-22": "Hobbit Day",
    "09-23": "Checkers Day",
    "09-24": "Punctuation Day",
    "09-25": "Comic Book Day",
    "09-26": "Love Note Day",
    "09-27": "Crush a Can Day",
    "09-28": "Good Neighbor Day",
    "09-29": "Coffee Day",
    "09-30": "Hot Mulled Cider Day",
    "10-01": "World Vegetarian Day",
    "10-02": "Name Your Car Day",
    "10-03": "Techies Day",
    "10-04": "Taco Day",
    "10-05": "Do Something Nice Day",
    "10-06": "Mad Hatter Day",
    "10-07": "Frappé Day",
    "10-08": "Pierogi Day",
    "10-09": "Beer and Pizza Day",
    "10-10": "World Mental Health Day",
    "10-11": "Sausage Pizza Day",
    "10-12": "Gumbo Day",
    "10-13": "Train Your Brain Day",
    "10-14": "Dessert Day",
    "10-15": "Grouch Day",
    "10-16": "Boss's Day",
    "10-17": "Pasta Day",
    "10-18": "Chocolate Cupcake Day",
    "10-19": "Evaluate Your Life Day",
    "10-20": "Sloth Day",
    "10-21": "Reptile Awareness Day",
    "10-22": "Nut Day",
    "10-23": "Mole Day",
    "10-24": "Food Day",
    "10-25": "Punk for a Day Day",
    "10-26": "Pumpkin Day",
    "10-27": "Black Cat Day",
    "10-28": "Chocolate Day",
    "10-29": "Internet Day",
    "10-30": "Candy Corn Day",
    "10-31": "Halloween",
    "11-01": "Authors' Day",
    "11-02": "Deviled Egg Day",
    "11-03": "Sandwich Day",
    "11-04": "Candy Day",
    "11-05": "Donut Day",
    "11-06": "Saxophone Day",
    "11-07": "Bittersweet Chocolate Day",
    "11-08": "Cappuccino Day",
    "11-09": "Go to an Art Museum Day",
    "11-10": "Vanilla Cupcake Day",
    "11-11": "Veterans Day",
    "11-12": "Chicken Soup for the Soul Day",
    "11-13": "Kindness Day",
    "11-14": "Pickle Day",
    "11-15": "Clean Out Your Refrigerator Day",
    "11-16": "Fast Food Day",
    "11-17": "Baklava Day",
    "11-18": "Mickey Mouse Day",
    "11-19": "Carbonated Beverage Day",
    "11-20": "Peanut Butter Fudge Day",
    "11-21": "World Television Day",
    "11-22": "Go for a Ride Day",
    "11-23": "Espresso Day",
    "11-24": "Sardines Day",
    "11-25": "Shopping Reminder Day",
    "11-26": "Cake Day",
    "11-27": "Thanksgiving (USA)",
    "11-28": "Black Friday",
    "11-29": "Electronic Greetings Day",
    "11-30": "Mousse Day",
    "12-01": "World AIDS Day",
    "12-02": "Fritters Day",
    "12-03": "Make a Gift Day",
    "12-04": "Cookie Day",
    "12-05": "Ninja Day",
    "12-06": "Microwave Oven Day",
    "12-07": "Pearl Harbor Remembrance Day",
    "12-08": "Brownie Day",
    "12-09": "Pastry Day",
    "12-10": "Human Rights Day",
    "12-11": "Noodle Ring Day",
    "12-12": "Gingerbread House Day",
    "12-13": "Cocoa Day",
    "12-14": "Monkey Day",
    "12-15": "Cupcake Day",
    "12-16": "Chocolate-Covered Anything Day",
    "12-17": "Maple Syrup Day",
    "12-18": "Bake Cookies Day",
    "12-19": "Hard Candy Day",
    "12-20": "Sangria Day",
    "12-21": "Winter Solstice",
    "12-22": "Date Nut Bread Day",
    "12-23": "Festivus",
    "12-24": "Christmas Eve",
    "12-25": "Christmas Day",
    "12-26": "Kwanzaa Begins",
    "12-27": "Fruitcake Day",
    "12-28": "Card Playing Day",
    "12-29": "Pepper Pot Day",
    "12-30": "Bacon Day",
    "12-31": "New Year's Eve"
};

export function holidayForDate(date = new Date()) {
  const key = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
  return SOCIAL_FUSION_HOLIDAYS[key] ?? null;
}